var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecordingBlackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99967 0C2.52692 0 1.33301 1.19391 1.33301 2.66667V13.3333C1.33301 14.8061 2.52692 16 3.99967 16H11.9997C13.4724 16 14.6663 14.8061 14.6663 13.3333V2.66667C14.6663 1.19391 13.4724 0 11.9997 0H3.99967ZM10.333 8.57736C10.7775 8.32076 10.7775 7.67926 10.333 7.42266L7.33301 5.69061C6.88856 5.43401 6.33301 5.75476 6.33301 6.26796L6.33301 9.73207C6.33301 10.2453 6.88856 10.566 7.33301 10.3094L10.333 8.57736Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordingBlackIcon);
export default __webpack_public_path__ + "static/media/RecordingBlackIcon.696784e7920493b023121fe601059a12.svg";
export { ForwardRef as ReactComponent };